import { Calendar } from 'lucide-react';
import { fmtDate } from '../../../helpers/Project-Report/utils/helpers';

const DateRangePanel = ({ start, end, accent, onChange, onApply, onCancel }) => (
  <div
    style={{
      position: 'absolute', top: 'calc(100% + 4px)', left: 0,
      zIndex: 400, background: '#fff', borderRadius: '16px',
      border: '1.5px solid #e2e8f0', boxShadow: '0 16px 48px rgba(0,0,0,0.16)',
      padding: '16px', minWidth: '280px', animation: 'dropFadeIn 0.16s ease',
    }}
    onMouseDown={(e) => e.stopPropagation()} // Prevent outside-click handler from firing
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '12px' }}>
      <Calendar size={14} color={accent} />
      <span style={{ fontSize: '12px', fontWeight: '700', color: '#0f172a' }}>Pilih Rentang Tanggal</span>
    </div>

    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '14px' }}>
      <div>
        <label style={{ fontSize: '10.5px', fontWeight: '600', color: '#64748b', display: 'block', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Tanggal Mulai</label>
        <input
          type="date"
          value={start}
          onChange={(e) => onChange(e.target.value, end)}
          style={{
            width: '100%', padding: '8px 10px', borderRadius: '8px',
            border: `1.5px solid ${start ? accent : '#e2e8f0'}`,
            fontSize: '12.5px', color: '#0f172a', outline: 'none',
            boxSizing: 'border-box', fontFamily: "'Inter', sans-serif",
            boxShadow: start ? `0 0 0 3px ${accent}18` : 'none',
          }}
          onFocus={(e) => { e.target.style.borderColor = accent; e.target.style.boxShadow = `0 0 0 3px ${accent}18`; }}
          onBlur={(e) => { e.target.style.borderColor = start ? accent : '#e2e8f0'; }}
        />
      </div>
      <div>
        <label style={{ fontSize: '10.5px', fontWeight: '600', color: '#64748b', display: 'block', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Tanggal Selesai</label>
        <input
          type="date"
          value={end}
          min={start || undefined}
          onChange={(e) => onChange(start, e.target.value)}
          style={{
            width: '100%', padding: '8px 10px', borderRadius: '8px',
            border: `1.5px solid ${end ? accent : '#e2e8f0'}`,
            fontSize: '12.5px', color: '#0f172a', outline: 'none',
            boxSizing: 'border-box', fontFamily: "'Inter', sans-serif",
            boxShadow: end ? `0 0 0 3px ${accent}18` : 'none',
          }}
          onFocus={(e) => { e.target.style.borderColor = accent; e.target.style.boxShadow = `0 0 0 3px ${accent}18`; }}
          onBlur={(e) => { e.target.style.borderColor = end ? accent : '#e2e8f0'; }}
        />
      </div>
    </div>

    {/* Preview */}
    {start && end && (
      <div style={{ padding: '8px 12px', borderRadius: '8px', background: `${accent}10`, marginBottom: '12px', fontSize: '11.5px', color: accent, fontWeight: '600', textAlign: 'center' }}>
        {fmtDate(start)}  →  {fmtDate(end)}
      </div>
    )}

    {/* Buttons */}
    <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
      <button
        onClick={onCancel}
        style={{ padding: '7px 16px', borderRadius: '8px', border: '1.5px solid #e2e8f0', background: '#fff', color: '#64748b', fontSize: '12px', fontWeight: '600', cursor: 'pointer', transition: 'all 0.2s' }}
        onMouseEnter={(e) => { e.currentTarget.style.background = '#f1f5f9'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; }}
      >
        Batal
      </button>
      <button
        onClick={onApply}
        disabled={!start || !end}
        style={{
          padding: '7px 16px', borderRadius: '8px', border: 'none',
          background: start && end ? accent : '#e2e8f0',
          color: start && end ? '#fff' : '#94a3b8',
          fontSize: '12px', fontWeight: '700', cursor: start && end ? 'pointer' : 'not-allowed',
          transition: 'all 0.2s',
        }}
        onMouseEnter={(e) => { if (start && end) e.currentTarget.style.filter = 'brightness(1.1)'; }}
        onMouseLeave={(e) => { e.currentTarget.style.filter = 'none'; }}
      >
        Apply
      </button>
    </div>
  </div>
);

export default DateRangePanel;
